import * as React from 'react'
import Category from '../Category'
import type { GetServerDataProps, GetServerDataReturn, PageProps } from "gatsby"
import * as t from '../types'
import getStory from './getStory'
import fetchCategoryData from './fetchCategoryData'
import Page404 from 'pages/404'

type ServerData = {
  data: t.Props['data']
}

export default function CategoryWrapper(props: PageProps & { serverData: ServerData }) {
  if(!props.serverData) {
    return <Page404 location={props.location} />
  }

  const categoryProps:t.Props = {
    location: props.location,
    pageContext: {
      brandPath: 'erwinmueller',
      filteredCategories: [],
      objectID: props.serverData.data.category.contentfulID,
    },
    data: props.serverData.data
  }
  return <Category {...categoryProps}/>
}

export async function getServerData(context:GetServerDataProps):GetServerDataReturn<ServerData> {
  const isSSR = !context.url.endsWith('.json')
  if(isSSR && !context.url.endsWith('/')) {
    return {
      status: 301,
      headers: {
        Location: context.url + '/',
      },
    }
  }

  const urlPath = `/category/${context.params!['*'] as string}`
  const page = parseInt(urlPath.split('/').pop()?.split('-').pop() as string)
  
  if(Number.isNaN(page)) {
    return {
      status: 404,
      headers: {},
    }
  }

  const [categoryId, categoryData] = await fetchCategoryData({urlPath})

  if(!categoryData || !categoryId) {
    return {
      status: 404,
      headers: {},
    }
  }

  return {
    status: 200,
    headers: {},
    props: {
      data: {
        category: {
          ...categoryData,
          story: await getStory({page, categoryId}),
        }
      }
    }
  }
}